import { client } from './client'

export type ChatPendingChangeSetStatus = 'Pending' | 'Confirmed' | 'Cancelled' | 'PartiallyFailed'
export type ChatPendingChangeType = 'Create' | 'Update' | 'Relationship' | 'Import' | 'SharedQuery' | 'WikiPage'

export interface ChatPendingChangeSetItem {
  id: string
  changeType: ChatPendingChangeType
  targetWorkItemId: number | null
  targetPendingItemId: string | null
  targetExternalId: string | null
  relatedWorkItemId: number | null
  relatedPendingItemId: string | null
  proposedValuesJson: string
  beforeValuesJson: string | null
  removedByUser: boolean
  applied: boolean
  error: string | null
  itemIndex: number
  isDuplicate: boolean
  existingWorkItemNumber: number | null
}

export interface ChatPendingChangeSet {
  id: string
  chatId: string
  status: ChatPendingChangeSetStatus
  isInterrupted: boolean
  proposedAt: string
  resolvedAt: string | null
  items: ChatPendingChangeSetItem[]
}

export interface ChatPendingSubmitItemResult {
  itemId: string
  success: boolean
  error: string | null
}

export interface ChatPendingSubmitResult {
  appliedCount: number
  failedCount: number
  items: ChatPendingSubmitItemResult[]
}

export interface ChatPendingRemoveResult {
  itemId: string
  cascadeRemovedItemIds: string[]
}

export const chatPendingChangesApi = {
  get: (projectId: string, chatId: string) =>
    client
      .get<ChatPendingChangeSet | null>(`/projects/${projectId}/chats/${chatId}/pending-changes`)
      .then((r) => r.data),

  submit: (projectId: string, chatId: string, confirmedItemIds: string[], excludedItemIds: string[]) =>
    client
      .post<ChatPendingSubmitResult>(`/projects/${projectId}/chats/${chatId}/pending-changes/submit`, {
        confirmedItemIds,
        excludedItemIds,
      })
      .then((r) => r.data),

  cancel: (projectId: string, chatId: string) =>
    client.post(`/projects/${projectId}/chats/${chatId}/pending-changes/cancel`).then((r) => r.data),

  removeItem: (projectId: string, chatId: string, itemId: string) =>
    client
      .delete<ChatPendingRemoveResult>(`/projects/${projectId}/chats/${chatId}/pending-changes/items/${itemId}`)
      .then((r) => r.data),
}
